import {RouteNameEnum} from "@/v2/enumerate/route";

const accept = [{
	path: "accept",
	name: RouteNameEnum.GLORY_ACCEPT,
	meta: {
		permission: 69001,
		breadcrumb: [{
			key: "glory.accept.index",
			value: null
		}]
	},
	component: () => import("@/page/content/glory/accept/index.vue"),
}];

export default accept;
